// src/components/homepage/JourneyTeaser.jsx
import { Link } from "react-router-dom";
import JourneyImage from "../../assets/personal/summit/s1a.jpg"; // adjust path if needed

export default function JourneyTeaser({ title, text, cta, link }) {
  return (
    <section className="flex flex-col md:flex-row justify-center items-center py-4 px-2 gap-6">
        
        {/* Left: Text */}
        <div className="md:w-2/3 text-center md:text-left">
          <h2 className="text-white text-4xl md:text-5xl font-bold mb-6">{title}</h2>
<p className="text-grayText text-lg md:text-xl mb-4">
  From running marathons to conquering Colorado 14ers, my journey in high-performance training has been one of discipline, resilience, and discovery. Each challenge taught me the importance of endurance, strength, and mental focus, shaping the philosophy behind Kalon Fitness.
</p>

<p className="text-grayText text-lg md:text-xl mb-4">
  Along the way, I experimented with different training methods, recovery strategies, and nutrition plans, learning what truly works for sustainable results. This hands-on experience helped me create a system that balances intensity, consistency, and individual needs for every client.
</p>

<p className="text-grayText text-lg md:text-xl mb-4">
  My approach is designed to help others achieve peak performance through structured, science-backed methods. I focus on:
</p>

          <ul className="text-grayText text-lg md:text-xl list-disc list-inside mb-6 space-y-1">
            <li>Endurance development for stamina and resilience</li>
            <li>Strength & aesthetics for a functional, balanced physique</li>
            <li>Sport-specific techniques to excel in any athletic pursuit</li>
            <li>Nutrition strategies for energy, recovery, and long-term health</li>
          </ul>
          <Link to={link}>
            <button className="bg-neonTurquoise text-black font-bold py-3 px-6 rounded-lg hover:brightness-110 transition duration-300">
              {cta}
            </button>
          </Link>
        </div>

        {/* Right: Image */}
        <div className="md:w-1/3 flex justify-center md:justify-end">
          <img
            src={JourneyImage}
            alt="Journey"
            className="w-full h-auto rounded-lg shadow-lg hover:scale-105 transition-transform duration-300"
          />
        </div>

    </section>
  );
}
